<div
  [kgrLoading]="state() === ComponentStates.loading"
  [kgrLoadingBlocking]="true"
  class="kgr-region kgr-region--secondary kgr-region--bordered"
>
  @if (hasErrors) {
    <kgr-errors errors="Bitte überprüfe die Eingabe deiner E-Mail-Adresse."></kgr-errors>
  }
  @if (apiError) {
    <div class="kgr-alert kgr-alert--error kgr-row">
      @switch (apiError.code) {
        @case (404) {
          <ng-container i18n> Leider existiert kein Benutzer mit dieser E-Mail Adresse. </ng-container>
        }
        @default {
          <ng-container i18n>Es ist leider ein Fehler aufgetreten: {{ apiError.message }}</ng-container>
        }
      }
    </div>
  }

  <p class="kgr-row" i18n i18n>
    Bitte geben Sie hier die E-Mail Adresse ein, mit der Sie bei uns registriert sind, damit wir Ihnen einen Link zum Zurücksetzen Ihres
    Passworts zusenden können.
  </p>
  <form (submit)="onSubmit()" class="js-test-loginForm kgr-row">
    <kgr-form-field label="E-Mail" i18n-label>
      <input [formControl]="control" type="email" class="kgr-input" autocomplete="email" required />
    </kgr-form-field>

    <div class="kgr-inputGroup">
      <button type="submit" class="kgr-button kgr-button--accent" i18n>Passwort zurücksetzen</button>
    </div>
  </form>
</div>
